module.exports = __webpack_public_path__ + "media/src/assets/Images/AppSectionBackground-4cc136716dfbe728e5ab9b5f3366c6be.svg";